import { getConfig } from '@kursk/../../config/config';
import { useRouter } from 'next/router';
import React from 'react';
import QRCode from 'react-qr-code';
import styles from './QrCodeForOrganization.module.scss';

export const QrCodeForOrganization = () => {
  const router = useRouter();
  const config = getConfig();
  const link = `${config.portal.url}/iframe/organizations/${router.query.sysName}`
  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <img src="/images/muza-logo.png" alt="" />
        </div>
        <div className={styles.code}>
          <QRCode
            size={294}
            value={link}
          />
        </div>
        <div className={styles.text}>Отсканируйте QR-код, чтобы купить билеты</div>
      </div>
    </div>
  )
}
